<ng-container>
  <div
    class="prismic-text"
    [ngClass]="[addClass !== '' ? addClass : '']"
    [innerHTML]="htmlText"
  ></div>
</ng-container>
